import React, { useState } from "react";
import AddPropertySearchBar from "../../components/Form/AddpropertySearchbar";
import LandlordDashboard from "../../components/LandLord/LandlordDashboard";
import LandLordTestSummary from "./LandLordTestSummary";

export default function ManageLands() {
  const [showTable, setShowTable] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  const handleViewUnits = (property) => {
    setSelectedProperty(property);
    setShowTable(true);
  };

  const handleBackToCards = () => {
    setShowTable(false);
    setSelectedProperty(null);
  };

  const properties = [
    {
      title: "Lakeside Villas",
      location: "City 1, Area 1",
      occupied: 7,
      vacant: 5,
      totalUnits: 12,
      expectedRent: "UGX 4,500,000",
      rentCollected: 10,
      rentCollectedThisMonth: "UGX 1,200,000"
    },
    {
      title: "Mountain View",
      location: "City 2, Area 3",
      occupied: 4,
      vacant: 8,
      totalUnits: 12,
      expectedRent: "UGX 3,800,000",
      rentCollected: 6,
      rentCollectedThisMonth: "UGX 900,000"
    },
    {
      title: "Downtown Lofts",
      location: "City 3, Area 2",
      occupied: 10,
      vacant: 2,
      totalUnits: 12,
      expectedRent: "UGX 5,200,000",
      rentCollected: 11,
      rentCollectedThisMonth: "UGX 1,500,000"
    },
    {
      title: "Sunset Residences",
      location: "City 1, Area 5",
      occupied: 8,
      vacant: 5,
      totalUnits: 12,
      expectedRent: "UGX 4,800,000",
      rentCollected: 7,
      rentCollectedThisMonth: "UGX 2,100,000"
    },
    {
      title: "Maple Heights",
      location: "City 2, Area 7",
      occupied: 12,
      vacant: 0,
      totalUnits: 12,
      expectedRent: "UGX 6,000,000",
      rentCollected: 12,
      rentCollectedThisMonth: "UGX 6,000,000"
    },
    {
      title: "Lakeside Court",
      location: "City 4, Area 1",
      occupied: 6,
      vacant: 6,
      totalUnits: 12,
      expectedRent: "UGX 3,600,000",
      rentCollected: 5,
      rentCollectedThisMonth: "UGX 1,200,000"
    },
  ];

  return (
    <div className="w-full h-screen flex-row items-center justify-center">
      {!showTable && (
        <div className="flex max-w-[1080px] w-full px-[30px] py-[30px]">
          <AddPropertySearchBar showAddPropertyButton={true}/>
        </div>
      )}
      <div className="px-0 lg:px-[30px]">
        <LandlordDashboard 
          properties={properties}
          showTable={showTable}
          selectedProperty={selectedProperty}
          onViewUnits={handleViewUnits}
          onBackToCards={handleBackToCards}
        />
      </div> 
    </div>
  )
}